<template>
<div class="gonggao">
 <!-- 标题 -->
       <div class="tit2">
           <img src="../assets/Notice notice.png" alt="###" class="img1"> <br>
           <img style="width:32px;height:32px;" class="img2" src="../assets/zuop.png" alt="###">
           <h1>新闻公告</h1>
       </div>

       <!-- 公告内容 -->
       <div class="gaocontent">

        <div v-for="(item,index) in gonggaoget" :key="item.id" class="gct">
             <!-- 日期 -->
             <div class="date">
     
                 <h1>{{rqgao[index]}}</h1>
                 <span>{{year[index]}}</span>
                 <p class="date-logos"></p>
             </div>
           <div @click="gaotit(index)" class="titles">
               <p class="gaopa">{{gonggaoget[index].title}}</p>
           </div>
           
           <div class="cont">
               <span class="contsp1">浏览量：{{gonggaoget[index].status}}</span> <span class="contsp2">发布者：大赛组委会</span>
               <p @click="gaotit(index)" class="gonggao-cont-p1">
                 {{gonggaoget[index].message}}
               </p>
               
               <div class="gonggao-jt">
    <img class="jiantou" src="../assets/jiantou.png" alt="###"> 
         </div>
           </div>
       
         </div>
        
       </div>
   
<router-link to="/gaolist"><qgengduo></qgengduo> </router-link> 
  

</div>
</template>

<script type="text/javascript">
import qgengduo from '../components/QgengDuo'
import axios from "axios";

export default {
  data(){
      return{
          notice:[1,2,3],
          gonggaoget:[],
         rqgao:[],
         year:[],
         titc:''
      }
  },
     mounted(){

 this.onLoad();


},
methods: {
    fontNumber (date) {
  const length = date.length
  if (length > 30) {
    var str = ''
    str = date.substring(0, 30) + '......'
    return str
  } else {
    return date
  }
},
     // 时间
 timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
 
  var   M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var   D = this.change(date.getDate()) + '';
  var   h = this.change(date.getHours()) + ':';
  var   m = this.change(date.getMinutes()) + ':';
  var   s = this.change(date.getSeconds());
    return M+'-'+D;
},
     // 时间
 timestampToTimesa(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var  Y = date.getFullYear() + '';
  var   M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var   D = this.change(date.getDate()) + '';
  var   h = this.change(date.getHours()) + ':';
  var   m = this.change(date.getMinutes()) + ':';
  var   s = this.change(date.getSeconds());
    return Y;
},
change(t) {
    if (t < 10) {
        return "0" + t;
    } else {
        return t;
    }
 
},
    onLoad(){
      axios({
  method:'get',
  url:this.$apiUrl,
  //  headers: {'X-Requested-With': 'XMLHttpRequest'},
//   timeout: 1000,
}).then(res=> {
    let a = res.data;
this.gonggaoget = a.data.new;
for (let index = 0; index < this.gonggaoget.length; index++) {
      this.rqgao.push(this.timestampToTime(this.gonggaoget[index].create_time))
 this.year.push(this.timestampToTimesa(this.gonggaoget[index].create_time))
}
}).catch(error =>{
    console.log(error);
})
},
gaotit(index){

      this.$router.push({path:"/GongGaoson"});
    //   console.log(this.gaolistdata[index].id);
      sessionStorage.setItem('xinwid',this.gonggaoget[index].id);
    //   console.log(this.gonggaoget[index].id,'ID')

}
},
  components:{
      qgengduo
  }

}
</script>

<style>
.gonggao{
     height:7rem;
     background: #F9F9F9;
     overflow: hidden;

}
/* 标题 */
 .tit2{
     text-align: center;
     margin-top: 0.47rem;
}
 .img1{
     float:none;
}
 .img2,.tit2>h1{
     display: inline-block;
     vertical-align: middle;
     margin-top: -0.27rem;
     font-size: 0.28rem;
}
 .img2{
     width: 0.32rem;
     height: 0.32rem;
}
 .tit>h1{
     font-size: 0.32rem;
     font-weight: bold;
     color: #202020;
}
/* 公告内容 */
 .gaocontent{
     width: 13.5rem;
     margin: 0.73rem auto;
     display: flex;
     justify-content:space-around;
     flex-wrap: nowrap;
}
 .gct{
     width: 4.2rem;
     position: relative;
     overflow: hidden;
}
/* 日期 */
 .date{
     height: 3rem;
     float: left;
     margin-top: 0.15rem;
}
 .date>h1{
     width: 0.92rem;
     height: 0.4rem;
     font-size: 0.3rem;
     font-weight: bold;
     font-style: italic;
     color: #202020;
     overflow: hidden;
     white-space: nowrap;
}
 .date>span{
     width: 0.45rem;
     height: 0.24rem;
     font-size: 0.18rem;
     font-weight: 500;
     font-style: italic;
     color: #959595;
     float: right;
     overflow: hidden;
     white-space: nowrap;
}
 .date-logos{
     width: 0.79rem;
     height: 0.1rem;
     background: #999999;
     margin-top: -0.13rem;
     margin-left: 0.05rem;
}
/* 新闻标题 */
 .titles{
     width: 3.03rem;
     cursor: pointer;
     font-size: 0.15rem;
     font-weight: bold;
     color: #000000;
     line-height: 0.45rem;
     text-align: left;
     float:right;
     font-size: 0.18rem;
}
 .gaopa{
     width: 3.03rem;
     height: 0.9rem;
     overflow: hidden;
     text-overflow: ellipsis;
     text-overflow: -o-ellipsis-lastline;
     display: -webkit-box;
     -webkit-line-clamp: 2;
     -webkit-box-orient: vertical;
}
/* 内容 */
 .cont{
     width: 3.03rem;
     height: 1.5rem;
     float: right;
     position: relative;
     margin-top: 0.10rem;
}
 .cont>span{
     font-size: 0.14rem;
     font-weight: 500;
     color: #949494;
     line-height: 0.24rem;
}
 .contsp2{
     margin-left: 0.2rem;
}
 .cont>p{
     height: 1.15rem;
     font-size: 0.13rem;
     font-weight: 400;
     color: #949494;
     line-height: 0.3rem;
     margin-top: 0.2rem;
     text-overflow: -o-ellipsis-lastline;
     overflow: hidden;
     text-overflow: ellipsis;
     display: -webkit-box;
     -webkit-line-clamp: 4;
     -webkit-box-orient: vertical;
}
.gonggao-cont-p1::after{
    content: "...";

 padding-left: 30px;
 background: -webkit-linear-gradient(left, transparent, #fff 50%);
 background: -o-linear-gradient(right, transparent, #fff 50%);
 background: -moz-linear-gradient(right, transparent, #fff 50%);
  background: linear-gradient(to right, transparent, #fff 50%);
}
 
/* 箭头 */
.gonggao-jt{
    width: 0.36rem;
    height: 9px;

    text-align: center;
     position: absolute;
     bottom: -0.3rem;
     right: 0;
     float: right;

}
@media screen and (max-width: 1320px) {
    .gonggao-jt {
        bottom: -0.5rem;
    }
}
 .jiantou{
      width: 0.36rem;
    height: 0.09rem;
    
}
 
</style>


// WEBPACK FOOTER //
// src/components/GongGao.vue